import { render, staticRenderFns } from "./scanFile.vue?vue&type=template&id=8da5dd62&scoped=true&"
import script from "./scanFile.vue?vue&type=script&lang=js&"
export * from "./scanFile.vue?vue&type=script&lang=js&"
import style0 from "./scanFile.vue?vue&type=style&index=0&id=8da5dd62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8da5dd62",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\myProject\\cbi-site-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8da5dd62')) {
      api.createRecord('8da5dd62', component.options)
    } else {
      api.reload('8da5dd62', component.options)
    }
    module.hot.accept("./scanFile.vue?vue&type=template&id=8da5dd62&scoped=true&", function () {
      api.rerender('8da5dd62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workplace/components/scanFile.vue"
export default component.exports